export default __webpack_public_path__ + "static/media/backgroundimg3.3f609f44.png";